import React from 'react'
import { observer } from 'mobx-react-lite'
import AuthorizationInputs from '../../components/forms/AuthorizationInputs'
import RootStore from '../../store/RootStore'
import { useNavigate } from 'react-router-dom'

type Props = {}

const Login = observer((props: Props) => {
  const navigate = useNavigate()

  const { username, password } = RootStore.authUi

  const [error, setError] = React.useState<any>()
  const [success, setSuccess] = React.useState(false)

  const hundleLogin = async (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    try {
      await RootStore.authStore.login({ username, password })
      setError(null)
      setSuccess(true)
      setTimeout(() => {
        navigate('/')
      }, 1500)
    } catch (error: any) {
      const data = error.response?.data
      if (data.property) {
        setError(data.property)
      } else {
        setError({ password: error.message })
      }
    }
  }

  return (
    <form className="Authorization-card-form">
      <AuthorizationInputs
        title="Имя пользователя"
        type="text"
        error={error?.username ?? null}
        defaultValue={username}
        onChange={(event) => {
          RootStore.authUi.setUsername(event.target.value)
        }}
      />
      <AuthorizationInputs
        title="Пароль"
        type="password"
        error={error?.password ?? null}
        defaultValue={password}
        onChange={(event) => {
          RootStore.authUi.setPassword(event.target.value)
        }}
      />

      <button
        className={`Authorization-card-form-inputs-button ${
          success ? 'success' : ''
        }`}
        onClick={hundleLogin}
        disabled={success}
      >
        {success ? 'Успешно' : 'Войти'}
      </button>
    </form>
  )
})

export default Login
